export default __webpack_public_path__ + "static/IBMPlexSans-ThinItalic-Latin1-1562859921a68f81405b8e762570eb1b.woff";